import { render, staticRenderFns } from "./ActivateProduct.vue?vue&type=template&id=1963156a&"
import script from "./ActivateProduct.vue?vue&type=script&lang=js&"
export * from "./ActivateProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports